import React from 'react';
import { LocaleProvider } from '../../contexts/localeContext';
import SEO from '../SEO/SEO';
import langConfig from '../../../config/lang';
import Box from '../Box/Box';
import { CookiesBanner } from '../CookiesBanner/CookiesBanner';

export default function PageWrapper({ page, children }) {
    const lang = langConfig.langs.find((lng) => lng.value === page.lang);

    return (
        <LocaleProvider value={lang}>
            <SEO
                title={page.data.page_title}
                description={page.data.description}
                image={page.data.meta_image}
                slug={page.data.slug}
                canonical={page.data.canonical_url}
            />
            <Box display="flex" flexDirection="column" position="relative">
                {children}
            </Box>
            <CookiesBanner />
        </LocaleProvider>
    );
}
